
try {
(function($, win, doc, RAF) {
	RAF = win.RAF;

	var NETWORK_ONLINE;

	// method to process network status changes
	function TOGGLE_NETWORK_ONLINE() {
	    if (NETWORK_ONLINE === navigator.onLine || !doc.body) {
	        return;
	    }

	    // ignore first init with online state
	    if (typeof NETWORK_ONLINE === 'undefined' && navigator.onLine) {
	        return;
	    }

	    NETWORK_ONLINE = (navigator.onLine) ? true : false;

	    // requestAnimationFrame
	    RAF(function() {

	        // update class
	        if (navigator.onLine) {

	            $(doc.body).removeClass('offline');
	        } else {

	            $(doc.body).addClass('offline');
	        }
	    });
	};

	// watch online/offline events
	$(win).on('online', TOGGLE_NETWORK_ONLINE);
	$(win).on('offline', TOGGLE_NETWORK_ONLINE);

	RAF(function() {
		TOGGLE_NETWORK_ONLINE();
	})

	// one signal push notifications
	win.OneSignal = win.OneSignal || [];
	win.OneSignal.push(function() {
	    /* @export */
	    win.OneSignal.init({
	        appId: "52a9dbaa-5823-447d-af47-ec508f9c8043",
	    });
	});
	win.OneSignal.SERVICE_WORKER_PATH = 'sw.js';

	// load push.js script
	if (win.vk_load_push) {
		//vk_load_push();
	}

	var SW_MESSAGE_IDENTIFIER = 'o10n';

	function SW_PRELOAD(url) {
	    SW_POST_MESSAGE([3, url]);
	}
	win.swPreload = SW_PRELOAD;

	function WW_PRELOAD(preloadList, mouseX, mouseY) {
	    SW_BACKGROUND_WORKER_POST_MESSAGE([2, preloadList, mouseX, mouseY]);
	}
	win.wwPreload = WW_PRELOAD;

	// start cache preload
	function SW_PRELOAD_MOUSEDOWN() {
	    var href = $(this).attr('href');
	    if (href) {
	        SW_BACKGROUND_WORKER_STOP();
	        SW_PRELOAD(href);
	    }
	}

	// Service Worker onready callback
	function SW_ON_READY() {
	    var ctrl = serviceWorker.controller;
	    if (ctrl) {
	        return Promise.resolve(ctrl);
	    } else {
	        return new Promise(function(resolve) {
	            serviceWorker.ready.then(function() {
	                if (!serviceWorker.controller) {
	                    var wait_for_controller = function() {
	                        setTimeout(function() {
	                            if (serviceWorker.controller) {
	                                resolve(serviceWorker.controller);
	                            } else {
	                                wait_for_controller();
	                            }
	                        }, 500);
	                    }
	                    wait_for_controller();
	                } else {
	                    resolve(serviceWorker.controller);
	                }
	            });
	        });
	    }
	}

	// send message with callback to service worker
	function SW_POST_MESSAGE(data, callback) {

	    // wait for service worker
	    return SW_ON_READY()
	        .then(function(controller) {
	            return new Promise(function(resolve, reject) {

	                if (callback) {
	                    var channel = new MessageChannel();
	                    data.unshift(channel.port2);
	                    data.unshift(SW_MESSAGE_IDENTIFIER);

	                    // expect emmidiate confirmation
	                    channel.port1.onmessage = callback;

	                    // post message to service worker
	                    controller.postMessage(data, [channel.port2]);
	                } else {
	                    data.unshift(0);
	                    data.unshift(SW_MESSAGE_IDENTIFIER);

	                    // post message to service worker
	                    controller.postMessage(data);
	                }
	            });
	        });
	}


	var SW_BACKGROUND_WORKER, SW_BACKGROUND_WORKER_MESSAGE, SW_BACKGROUND_WORKER_ERROR;

	function SW_BACKGROUND_WORKER_STOP() {
	    if (SW_BACKGROUND_WORKER) {
	        SW_BACKGROUND_WORKER.terminate();
	    }
	}

	// start worker for service worker background tasks, e.g. cache pruning
	function SW_BACKGROUND_WORKER_POST_MESSAGE(data, channel) {
	    if (!SW_BACKGROUND_WORKER) {

	    	try {

		        // start shared worker
		        SW_BACKGROUND_WORKER = new Worker('/sw-worker.js');

		        // listen for messages from worker
		        SW_BACKGROUND_WORKER_MESSAGE = function(event) {
		            // preload list completed
		            if (event.data[0] === 3) {
		                if (win.wwC) {
		                    win.wwC(event.data[1]);
		                }
		            } else {
		                // forward to service worker
		                SW_POST_MESSAGE(event.data);
		            }
		        };
		        SW_BACKGROUND_WORKER.addEventListener('message', SW_BACKGROUND_WORKER_MESSAGE);

		        // stop background webworker and fetch requests on navigation
		        win.onbeforeunload = SW_BACKGROUND_WORKER_STOP;

		    } catch(err) {
		    	return;
		    }
	    }

	    // send to web worker 
	    if (channel) {
	        SW_BACKGROUND_WORKER.postMessage(data, [channel]);
	    } else {
	        SW_BACKGROUND_WORKER.postMessage(data);
	    }
	}

	// test availability of serviceWorker
	if ('serviceWorker' in navigator) {
	    win.swReady = SW_ON_READY;

	    try {

		    var serviceWorker = navigator.serviceWorker;

		    // start registration
		    serviceWorker.register('/sw.js', {
		        scope: '/'
		    }).then(function() {

			    // listen for messages from Service Worker
			    serviceWorker.addEventListener('message', function(event) {

			        var data = (event && event.data) ? event.data : false;

			        // detect PWA service worker event
			        if (data instanceof Array && data[0] == SW_MESSAGE_IDENTIFIER) {

			            // process event
			            switch (data[1].toString()) {
			                case "1": // callback result

			                    break;
			                default:
			                    console.error('sw', data);
			                    break;
			            }
			        }
			    });

			    // send init message
			    SW_POST_MESSAGE([1], function(event) {

			        // start web worker
			        SW_BACKGROUND_WORKER_POST_MESSAGE(event.data);
			    });

		    }).catch (function (error) {
			    console.error(error);
			});


		} catch (err) {

		}

		$('a[href]').on('mousedown touchstart', SW_PRELOAD_MOUSEDOWN);

	}

	var SW_VERSION = '10';
	var lastRegistration = localStorage.getItem('verkoop-sw-v' + SW_VERSION);
	if (!lastRegistration && win.swReady) {
	    win.swReady().then(function(ctrl) {
	        navigator.serviceWorker.getRegistration('/').then(function(registration) {
	            registration.update();
	            localStorage.setItem('verkoop-sw-v' + SW_VERSION, 1);
	            console.info('o10n.sw', 'forced update');
	        });
	    });
	}

	var MOUSEOVER_LINK;

	return;
    // temp (old client)
    if (!win.wwPreload || doc.cookie.indexOf('feo:debug') !== -1) {
        return;
    }

    function PRELOAD_URLS() {

        if (typeof MOUSE_X === 'undefined') {
            return;
        }

        // calculate links on page
        var preloadList = {};

        links.forEach(function(linkEl) {

            url = linkEl.pathname + linkEl.search;
            hash = url;

            var inview = (linkEl.hasAttribute('data-iv')) ? true : false;
            if (!inview) {
                return;
            }

            var rect = linkEl.getBoundingClientRect();
            if (rect.top === 0 && rect.left === 0) {
                return;
            } else {
                inview = [rect.left, rect.top];
            }

            if (hash in preloadList) {
                var i = 1;
                var numhash = hash + '-' + i;
                while (numhash in preloadList) {
                    i++;
                    numhash = hash + '-' + i;
                }
                hash = numhash;
            }


            preloadList[hash] = [url, inview[0], inview[1]];

        });

        if (MOUSEOVER_LINK) {
            preloadList[MOUSEOVER_LINK] = [MOUSEOVER_LINK, 0, 0, 1];
        }

        // web worker preload
        win.wwPreload(preloadList, MOUSE_X, MOUSE_Y);
    }

    // detect mouse position
    var MOUSE_X;
    var MOUSE_Y;

    var links = [];

    // init preload
    $lazy('a', [function(element) {
        $(element).attr('data-iv', 1);
    }, function(element) {
        $(element).attr('data-iv');
    }]);

    doc.onmousemove = function(e) {
        MOUSE_X = e.clientX;
        MOUSE_Y = e.clientY;
    }

    // setup inview
    //inView.offset(-50);

    // setup link event handlers
    var l = doc.links.length;
    for (var i = 0; i < l; i++) {

        linkEl = doc.links[i];

        if (!linkEl.href || linkEl.hostname.toLowerCase() !== 'www.verkoop.com' || !doc.body.contains(linkEl)) {
            continue;
        }

        linkEl.onmouseover = function() {
            if (this.hasAttribute('href')) {
                MOUSEOVER_LINK = this.pathname + this.search;
            } else {
                MOUSEOVER_LINK = false;
            }
        }
        linkEl.onmouseout = function() {
            if (this.hasAttribute('href') && MOUSEOVER_LINK === this.pathname + this.search) {
                MOUSEOVER_LINK = false;
            }
        }

        links.push(linkEl);
    }

    // confirm preload
    win.wwC = function(url) {
        links.forEach(function(linkEl, index) {
            linkUrl = linkEl.pathname + linkEl.search;
            if (linkUrl === url) {
                links.splice(index, 1);
            }
        });
    }

    setInterval(PRELOAD_URLS, 250);

})(jQuery, window, document);
} catch(e){_st_catch(e)}
